import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';
import imageJson from 'assets/images/image.json';
import { FormProvider, RHFTextField } from 'components/hook-form';
import LazyLoadImageHash from 'components/LazyLoadImage';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const EmailScreenContainer = styled('div')``;

type FormValuesProps = {
  email: string;
  apiError: string;
};

export default function EmailScreen({
  makeUser,
  methods,
  submitting,
}: {
  makeUser: () => void;
  methods: UseFormReturn<any, any>;
  submitting: boolean;
}) {
  const { t } = useTranslation();

  return (
    <EmailScreenContainer className='flex gap-[10%] max-w-[800px]'>
      <div className='text-center flex flex-col'>
        <h1 className='text-left mb-[5vh]'>{t('enter_email')}</h1>
        <FormProvider methods={methods} onSubmit={makeUser}>
          <RHFTextField
            name='email'
            placeholder='Email'
            className='w-full'
            variant='standard'
          />

          <LoadingButton
            type='submit'
            variant='contained'
            className='w-full mt-4'
            loading={submitting}
          >
            {t('next')}
          </LoadingButton>
        </FormProvider>
        <div className='mt-5 text-xs text-gray-500'>
          {t('privacy_notice')}{' '}
          <a
            href='https://makewebbetter.com/privacy-policy/?utm_source=MWB&utm_medium=WTthemes&utm_campaign=hubmarket'
            target='_blank'
            rel='noreferrer'
            className='no-underline text-[#2E96F3]'
          >
            {t('privacy_policy')}
          </a>
        </div>
      </div>
      <div className='hidden lg:block'>
        <LazyLoadImageHash
          image={imageJson.register}
          height='320px'
          width='310px'
        />
      </div>
    </EmailScreenContainer>
  );
}
